class UGProductShopNow extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".ug-product-buy-button");
    this.init();
  }

  init(){
    this.button?.addEventListener("click", this.handleClick.bind(this)); 
  }

  handleClick(){
    if(!this.button?.getAttribute("data-product-url")){
      return;
    }
    let productObj = JSON.parse(this.button.getAttribute("data-product-url"));
    let channelUrlList = productObj.channel_url_list;

    if(channelUrlList.length === 1){
      window.open(channelUrlList[0], "_blank");
    }else if(channelUrlList.length > 1){
      let market = this.button?.getAttribute("data-market");
      if(window.ugProductShowData.productShopOpenFn && typeof window.ugProductShowData.productShopOpenFn === "function"){
        window.ugProductShowData.productShopOpenFn(market,channelUrlList);
      }
    }
  }


}

customElements.define('ug-product-shop-now', UGProductShopNow);